import CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import { PRODUCT_FEED_TYPE } from '@src/quince-site-common/src/services/productFeedService/productFeedService.types'

import { SubCollection } from './domains/Collection'
import { SelectedFilter } from './domains/CollectionFilter'
import { SHOW_SECOND_IMAGE_ON_PRODUCT_TILES_SLUGS } from '@src/quince-site-common/src/utils/constants'

export function isCustomSection(section: CustomSection | SubCollection): section is CustomSection {
  return section.typename === 'CustomSection'
}

export function shouldShowBorder(currentIndex: number, sections: (SubCollection | CustomSection)[]) {
  const nextSection = sections[currentIndex + 1]
  const nextIsCustomSection = nextSection && isCustomSection(nextSection)
  const nextIsFaqSection = nextIsCustomSection && nextSection.sectionType === CUSTOM_SECTION_TYPE.ACCORDION
  const isLastSection = currentIndex === sections.length - 1
  const showBorderBottom = !nextIsFaqSection && !isLastSection
  return showBorderBottom
}

export const getSubCollections = (subCollections: (SubCollection | CustomSection)[]) => {
  // get only subcollections
  return subCollections.filter(sc => sc.typename !== 'CustomSection')
}

export const shouldShowSubCollectionCards = (subCollections: SubCollection[] = []) => {
  if (subCollections.length <= 1) {
    return false
  }
  const subCollectionWithCardData = subCollections.filter(sc => sc.imageDesktop !== undefined)
  return subCollections.length === subCollectionWithCardData.length
}

export const shouldEnrichCustomSection = (customSection: CustomSection) =>
  (customSection.sectionType === CUSTOM_SECTION_TYPE.PRODUCT_LIST_TWO ||
    customSection.sectionType === CUSTOM_SECTION_TYPE.PRODUCT_LIST_THREE) &&
  (customSection.productFeedType == PRODUCT_FEED_TYPE.CUSTOMER_TOP_SIMILAR_PRODUCTS ||
    customSection.productFeedType == PRODUCT_FEED_TYPE.FBT)

export const getEnrichedCustomSection = (
  customSection: CustomSection,
  subCollections: (SubCollection | CustomSection)[],
): CustomSection => {
  return {
    ...customSection,
    productFeedType: PRODUCT_FEED_TYPE.FBT,
    productFeedMetaData: {
      productCards: subCollections
        .filter(s => s.typename !== 'CustomSection')
        .map(s => s)
        .map(s => s.productCards)
        .flat(),
    },
  }
}

export const defaultSelectedFilter = new SelectedFilter({})

export const getFormattedSlug = (slug: string) => {
  let finalSlug = slug
  if (slug.startsWith('/')) {
    finalSlug = slug.slice(1)
  }
  return finalSlug
}

export const getShowSecondImageOnProductTilesValue = (slug: string): boolean => {
  return SHOW_SECOND_IMAGE_ON_PRODUCT_TILES_SLUGS.includes(slug)
}
